import React from "react";
import { Heart, Sparkles } from "lucide-react";
import { useT } from "@/lib/i18n";

const FAMILY_IMG = `${process.env.REACT_APP_BACKEND_URL}/api/uploads/family_pic.jpg`;

export default function MeetFamily() {
  const { t } = useT();
  return (
    <section
      id="meet-family"
      data-testid="meet-family-section"
      className="relative py-20 lg:py-28 bg-white overflow-hidden"
    >
      {/* Soft decorative shapes */}
      <div className="absolute top-10 -left-12 h-56 w-56 rounded-full bg-amber-100/50 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-12 right-0 h-72 w-72 rounded-full bg-sky-100/60 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-rose-100 text-rose-700 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em]">
            <Heart className="h-3 w-3 fill-rose-600 stroke-rose-600" />
            {t("meet.tag")}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-brand-navy leading-[1.1]">
            {t("meet.title1")}
            <span className="block text-brand-blue">{t("meet.title2")}</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed text-base sm:text-lg">
            {t("meet.body1")}
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed text-base sm:text-lg">
            {t("meet.body2")}
          </p>

          <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-4 py-2">
            <Sparkles className="h-4 w-4 text-amber-600" />
            <span className="text-sm font-semibold text-amber-800">
              {t("meet.imageCaption")}
            </span>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 relative">
          <div className="absolute -inset-4 bg-gradient-to-br from-sky-100 via-amber-50 to-rose-100 rounded-[2.5rem] blur-2xl -z-10" />
          <div className="relative rounded-[2rem] overflow-hidden border-4 border-white shadow-2xl bg-white">
            <img
              src={FAMILY_IMG}
              alt="The Oxford Cleaners family"
              className="w-full aspect-[4/5] sm:aspect-[5/6] lg:aspect-[4/5] object-cover" loading="lazy" decoding="async" />
            {/* Subtle warm overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-transparent to-transparent pointer-events-none" />
            {/* Family name strip */}
            <div className="absolute left-5 bottom-5 right-5 sm:left-7 sm:bottom-7 sm:right-auto rounded-2xl bg-white/95 backdrop-blur-md border border-white shadow-xl px-5 py-3">
              <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-amber-700">
                {t("meet.tag")}
              </p>
              <p className="font-display text-lg font-bold text-brand-navy mt-0.5">
                The Oxford Cleaners family
              </p>
              <p className="text-xs text-slate-500">Chandler, AZ</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
